
/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/


	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const about = () => `Informazioni`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const acceptance = () => `Accettazione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement = () => `Risultato`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementImageAltText = (params) => `Badge per ${params.name}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardAnotherCTA = () => `Premia un altro`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardCountSummary = (params) => `${params.count} assegnato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_heading = () => `Badges rivendicati`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_loginCTA_description = () => `Solo i membri di questa community possono vedere i dettagli delle richieste. Accedi per vedere i dettagli`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_noneAvailable = () => `Non sono disponibili richieste per questo risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_claimCTA = () => `Richiedi questo risultato`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_claimCountSummary = (params) => `${params.count} persone hanno rivendicato o ottenuto un badge per questo risultato, ma alcune richieste potrebbero non essere visibili se non sono state accettate.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_createNewDescription = () => `Portare un risultato nel tuo spazio è il primo passo per riconoscere i valori e le competenze che uniscono la tua comunità.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_createNewHeading = () => `Definisci un nuovo risultato`




	
/**
 * @param {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_deleteConfirm_description = (params) => `Vuoi eliminare le richieste dei membri ${params.name} e ${params.count} ? Questa azione non può essere annullata.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_deleteConfirm_heading = () => `Eliminare il risultato e tutte le richieste correlate?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_editCTA = () => `Modifica risultato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_edit_description = () => `Quando aggiorni un risultato, la nuova definizione verrà applicata ai membri della community che lo hanno precedentemente ottenuto e anche ai futuri risultati.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown>, timeAgo: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_invitedByNameAtTime = (params) => `Invitato da ${params.givenName} ${params.familyName} ${params.timeAgo}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_name = () => `Nome del risultato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_narrative = () => `Narrazione del risultato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_openClaimable_description = () => `Chiunque può rivendicare questo risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_other = () => `Risultati`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_share_description = () => `Condividi questo risultato con altri che potrebbero rivendicarlo o saperne di più. Ad esempio, puoi visualizzare o salvare il codice QR da aggiungere a una presentazione per invitare il pubblico a rivendicare un badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_youHaveClaimed_description = () => `Hai ottenuto con successo un badge per questo risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_all = () => `tutti i risultati`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_description = () => `I risultati ottenuti da una comunità mostrano cosa conta nella comunità.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action_other = () => `Azioni`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const adminRoleLabel = () => `Amministratore`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardBadgeCTA = () => `Invito a richiedere`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardBadgeCTA_description = () => `Riconosci direttamente i risultati ottenuti da un membro della community con un badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardCTA = () => `Invita`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_createUserIfNotExistsOption = () => `Avanzate: Crea un account per questo utente se non è ancora un membro`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_narrative_description = () => `Puoi inviare una descrizione del motivo per cui il membro si qualifica per questo risultato. Sarà inclusa nel badge award. Se c'è un URL che dimostra questo risultato sul web, puoi includerlo.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_narrative_placeholder = () => `Hanno completato un progetto...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_noneYet = () => `Nessun risultato raggiunto`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_recipientEmail = () => `E-mail del destinatario`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardedBadge = () => `Badge assegnato`




	
/**
 * @param {{ achievementName: NonNullable<unknown>, communityName: NonNullable<unknown>, badgeUrl: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardedBadge_email_description = (params) => `Congratulazioni, ti è stato assegnato un badge per il risultato ${params.achievementName} nella community ${params.communityName} .<inlang-LineFeed>
Puoi vedere il tuo badge qui e accedere per aggiornarlo:
${params.badgeUrl}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack = () => `Zaino`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_emptyStateCTA = () => `Visualizza tutti i risultati`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_emptyState_description = () => `Scopri alcuni dei risultati disponibili in questa community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadge = () => `Il tuo Badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadges_description = () => `Ecco i badge che hai guadagnato in questa community. Ogni badge riconosce un risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadges_heading = () => `I tuoi badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const badge_one = () => `badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const badge_other = () => `badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumb = () => `Briciole`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const cancelCTA = () => `Cancella`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_description = () => `Organizza i tuoi risultati per categoria per aiutare la tua community a capire cosa è più importante e cosa è più coerente.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_editCTA = () => `Modifica categorie`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_title = () => `Categorie di risultati`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category = () => `Categoria`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_achievementCount = () => `Conteggio dei risultati`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_name = () => `Nome della categoria`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_other = () => `Categorie`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_weight = () => `Peso`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_cancelFailError = () => `Errore durante l'archiviazione delle credenziali. Operazione non riuscita o annullata dall'utente. Non sono disponibili ulteriori dettagli.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_description = () => `Per condividere i tuoi badge tra diverse community e altri siti in cui utilizzi badge, puoi inviarli a un wallet. Questa app supporta wallet compatibili con`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_noPolyfillError = () => `Nessun Polyfill del gestore delle credenziali attivo in questo browser.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_walletSignupCTA_description = () => `Se non hai ancora un wallet compatibile, puoi registrarti per un nuovo wallet con`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimCTA = () => `Richiedi`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_adminOnly_description = () => `Questo risultato può essere conferito solo dagli amministratori della community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_allow = () => `Consenti richiesta badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimDisabled = () => `Non rivendicabile`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimEnabled = () => `Richiesta abilitata`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimRequiresSummary = () => `Questo risultato può essere rivendicato dai membri che possiedono un badge per:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_heading = () => `Configurazione della richiesta`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_noReviewsRequired_description = () => `Le richieste sono valide immediatamente e non necessitano di alcuna revisione.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_openClaimableCTA = () => `Richiedi di entrare a far parte della comunità`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_relatedAchievementNotFoundError = () => `Impossibile salvare le impostazioni dei risultati. Il risultato correlato richiesto non è stato trovato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_requiredAchievement = () => `Risultato richiesto `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_requiredAchievement_description = () => `Seleziona un risultato che un membro deve già possedere per poter richiedere questo badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewRequires = () => `Conseguimento richiesto per esaminare le richieste`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewRequires_description = () => `Seleziona un risultato che qualifichi un membro come revisore delle richieste per questo risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequired = () => `Numero di recensioni richieste (fino a 5)`




	
/**
 * @param {{ reviewsRequired: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequiredSummary = (params) => `Le richieste richiedono la revisione da parte dei membri ${params.reviewsRequired} che possiedono il risultato:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequired_description = () => `Inserisci il numero di recensioni richieste prima che le richieste diventino valide. Se non vi sono recensioni, le richieste sono immediatamente valide.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_unexpectedSaveError = () => `Si è verificato un problema imprevisto durante il salvataggio della configurazione dei Risultati.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userMeetsRequirement = () => `Soddisfi questo requisito.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userNotMeetRequirement_heading = () => `Non idoneo a richiedere`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userNotMeetsRequirement = () => `Non possiedi ancora questo prerequisito.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrativeInstructions = () => `Descrivi il tuo risultato in poche frasi.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrative_description = () => `Puoi inviare una descrizione del motivo per cui ti qualifichi per questo risultato. Sarà inclusa nel tuo badge award. Se c'è un URL che prova questo risultato sul web, puoi includerlo.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrative_placeholder = () => `Ho completato un progetto.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_achievementNotClaimableError = () => `Questo risultato non può essere rivendicato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_changeCTA = () => `Visualizza o modifica le impostazioni della tua richiesta.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_changeRejectedToAcceptedCTA = () => `Accettazione modifiche: accetta badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_claimBadgeCTA = () => `Richiedi il badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_claimedByAnonMember = () => `Questo badge è stato richiesto da un membro della community. Vedi i dettagli di questa richiesta qui sotto.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_couldNotObtainInvitationError = () => `Non è stato possibile ottenere l'invito per richiedere questo badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_editCTA = () => `Modifica richiesta`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_invitationEmailReconciliationError = () => `Non è stato possibile conciliare l'invito con gli indirizzi email degli utenti.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_invitationInvalidError = () => `Invito non valido.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_noExistingFoundError = () => `Non è stata trovata alcuna richiesta esistente.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_notFoundError = () => `Badge non trovato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_notFoundOrNotShareableError = () => `Richiesta non trovata o non condivisibile.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_rejectCTA = () => `Rifiutato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_sendToWalletCTA = () => `Invia al wallet`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareCTA = () => `Condividi questo badge`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareText_heading = (params) => `Ho richiesto un badge, ${params.name} .`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareUrlCopied = () => `URL di condivisione copiato negli appunti: `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusAccepted = () => `Richiesta accettata.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusAcceptedPublic = () => `Questo badge è stato accettato dal destinatario.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvited = () => `Sei invitato a richiedere un badge`




	
/**
 * @param {{ createdOn: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvitedFull_description = (params) => `Sei stato invitato a richiedere un badge per questo risultato su ${params.createdOn} , ma non lo hai ancora accettato. Puoi richiederlo ora o rifiutarlo. Se vuoi aggiungere prove, puoi farlo.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvited_description = () => `Sei stato invitato a reclamare un badge per questo risultato, ma non hai ancora accettato l'invito.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejected = () => `Badge rifiutato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejectedPublic_description = () => `Questo badge non è stato accettato dal destinatario. Si prega di contattare il destinatario per maggiori informazioni.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejected_description = () => `Hai rifiutato questo badge. Non apparirà sul tuo profilo e non potrà essere scaricato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUnacceptedPublic = () => `Questo badge non è stato ancora accettato dal destinatario. Torna a controllare presto.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUserAccepted = () => `Hai accettato questo badge`




	
/**
 * @param {{ createdOn: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUserAccepted_description = (params) => `Hai ottenuto questo risultato il ${params.createdOn} . È visibile agli altri membri della community. Puoi aggiungere ulteriori dettagli alla tua richiesta. Oppure puoi modificare la tua accettazione se non vuoi più questo badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusValidNoReviewRequired = () => `Questo badge non necessita di revisione ed è valido.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusValidSufficientReviews = () => `Questo badge ha ricevuto sufficienti recensioni ed è valido.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_unauthenticatedError = () => `Questo badge non può essere richiesto da utenti non autenticati.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_unauthenticatedUserEndorsementError = () => `Gli utenti non autenticati non possono approvare questo badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_userNotMeetsPrerequsiteError = () => `Non hai il prerequisito per questa richiesta.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_validFrom = () => `Valido da`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_validUntil = () => `Valido fino al`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_viewCTA = () => `Visualizza la richiesta del badge`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_youHaveAwarded = (params) => `Hai assegnato questo badge a ${params.givenName} ${params.familyName} .`




	
/**
 * @param {{ inviteeEmail: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_youHaveInvited = (params) => `Hai creato con successo un invito per ${params.inviteeEmail} . Possono unirsi alla community e richiedere un badge per questo risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_yourPreferredEmail = () => `La tua email preferita`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimed = () => `Reclamato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const clipboard_couldNotCopyError = () => `Impossibile copiare automaticamente negli appunti. Il tuo browser potrebbe non supportare questa operazione oppure la pagina potrebbe non essere servita tramite HTTPS.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const close = () => `Vicino`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const contactCTA = () => `Contatto`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const contentMissing = () => `Contenuto mancante`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const copyCTA = () => `Copia`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const createNewCTA = () => `Crea nuovo`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria = () => `Criteri`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_description = () => `Definisci cosa deve essere fatto per ottenere questo risultato. Puoi fare riferimento a una pagina web esterna se necessario.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_placeholder = () => `* Dimostrare la capacità di prendere iniziative...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_url = () => `URL dei criteri`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date = () => `Data`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const deleteCTA = () => `Eliminare`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const description = () => `Descrizione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const downloadCTA = () => `Download`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const earnedBadge = () => `Badge guadagnato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const editCTA = () => `Modificare`




	
/**
 * @param {{ message: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const email_transmissionError = (params) => `Errore durante l'invio dell'email: ${params.message}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseFormCTA = () => `Distintivo di approvazione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_alreadyRecommendedError = () => `Hai già raccomandato questa persona per questo risultato. I dati precedenti sono mostrati di seguito.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_description = (params) => `Aggiungi il tuo sostegno al badge di ${params.givenName} ${params.familyName} .`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_narrative_description = () => `Puoi aggiungere la tua approvazione o recensione su come questo membro si qualifica per questo risultato. Sarà incluso nel premio badge. Se c'è un URL che prova questo risultato sul web, puoi includerlo.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_addYoursCTA = () => `Aggiungi il tuo`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_couldNotIdentifyEmailAddressError = () => `Impossibile identificare un indirizzo email. Puoi effettuare questa approvazione via email dalla pagina dei risultati.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_other = () => `Approvazioni`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_updateCTA = () => `Aggiorna la tua approvazione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error = () => `Errore`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error_unauthorized = () => `Non autorizzato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const evidenceURL = () => `URL prova`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const familyName = () => `Cognome`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const givenName = () => `Nome`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home = () => `Home`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const identifierListLabel = () => `identificatore`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const identifierListLabel_other = () => `identificatori`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const image = () => `Immagine`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invitation_rejectConfirm = () => `Sei sicuro di voler rifiutare questo badge?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invitation_rejectConfirm_description = () => `Se rifiuti questo badge, non verrà mostrato sul tuo profilo né sarà verificabile. Puoi cambiare idea in futuro.`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const inviteJoinCTA_description = (params) => `Sei stato invitato a richiedere un badge e a unirti alla community ${params.name} . Conferma il tuo indirizzo email per continuare.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_achievementUnauthorizedError = () => `Non puoi assegnare questo risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_notFoundError = () => `Invito sconosciuto. Questo invito non esiste o potrebbe non essere più valido.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_recipientIdentifierRequiredError = () => `È obbligatorio l'identificativo del destinatario.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_unauthorizedNonAdminError = () => `Non puoi invitare altri a reclamare questo risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const linkedin_addToProfileButton_label = () => `Pulsante Aggiungi al profilo LinkedIn`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const logInCTA = () => `Login`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const logOutCTA = () => `Esci`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginCTA_description = () => `Se sei un utente registrato, puoi effettuare l'accesso per gestire le competenze in questa community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginInviteCTA = () => `Accedi per accettare l'invito`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginInviteCTA_description = () => `Sei stato invitato a guadagnare un badge e a unirti alla community. Completa la registrazione per continuare.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_agreeTermsError = () => `Per entrare a far parte della community devi accettare i termini.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_checkEmailCTA_description = () => `Controlla la tua email per trovare il codice di verifica.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_emailNotParsedError = () => `Devi inserire un indirizzo email valido per effettuare l'accesso.`




	
/**
 * @param {{ code: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_emailVerificationCodeIs = (params) => `Il tuo codice di verifica è: ${params.code}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_incorrectCodeError = () => `Codice errato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_invitationRequiredError = () => `Impossibile accedere con questo indirizzo email senza un invito. Controlla la tua email per un link di invito.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_sendCodeCTA = () => `Invia codice`




	
/**
 * @param {{ orgName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_toCommunityNameCTA = (params) => `Accedi a ${params.orgName}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_verificationCodeRequiredError = () => `È obbligatorio il codice di verifica.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const markdown_description = () => `È possibile immettere la formattazione del testo con Markdown.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const me = () => `Me`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const media_localMediaOnlyAvailableInDevError = () => `I media locali sono disponibili solo per gli ambienti di sviluppo.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member = () => `Membro`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_memberDetailsLabel = () => `Dettagli del membro`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_notFoundError = () => `Nessun membro trovato con questo ID.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_other = () => `Membri`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_otherUserProfileDescription = () => `Un utente associato a questa community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_settingsChangeUnauthenticedError = () => `Solo gli utenti autenticati possono modificare le impostazioni.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_share_description = () => `Puoi condividere un URL sul tuo profilo, dove altre persone possono vedere i badge che hai guadagnato. Sarà visibile solo agli altri membri della community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_yourProfileGreeting = () => `Questo è il tuo profilo.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const members_description = () => `Utenti associati a questa community.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const members_title = () => `Membri della comunità`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const membership = () => `Iscrizione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const mostAwardedAchievements = () => `I risultati più premiati`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const narrative = () => `Narrativa`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const notFound = () => `Non trovato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_editCTA = () => `Modifica organizzazione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_edit_description = () => `In qualità di amministratore dell'organizzazione, puoi aggiornare le informazioni descrittive sull'organizzazione.`




	
/**
 * @param {{ orgName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_inviteToJoin = (params) => `Invito a partecipare ${params.orgName}`




	
/**
 * @param {{ achievementName: NonNullable<unknown>, orgName: NonNullable<unknown>, inviteLink: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_inviteToJoin_description = (params) => `Sei stato invitato a richiedere un badge per il risultato ${params.achievementName}<inlang-LineFeed>
Richiedendo un badge, puoi unirti alla community ${params.orgName} . Clicca qui per unirti:<inlang-LineFeed>
${params.inviteLink}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_name = () => `Nome dell'organizzazione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_primaryColor = () => `Colore primario`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_url = () => `Homepage della comunità:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_usesOrca = () => `Questa comunità utilizza ORCA per riconoscere competenze e risultati.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organization_notFoundError = () => `Comunità ORCA non trovata.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const otherUserBadge_heading = (params) => `${params.givenName} Badge ${params.familyName}`




	
/**
 * @param {{ page: NonNullable<unknown>, maxPage: NonNullable<unknown>, count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const paginationSummary = (params) => `Pagina ${params.page} di ${params.maxPage} ( ${params.count} risultati totali)`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const previewCTA = () => `Anteprima`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const privacyPolicy = () => `Politica sulla riservatezza`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile = () => `Profilo`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile_editCTA = () => `Modifica impostazioni`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const qrCode = () => `Codice QR`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_genericError = () => `Impossibile registrarsi. Prova ad accedere di nuovo.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const requirement_statusInvalid = () => `Requisito non valido.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const saveCTA = () => `Salva`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const seeCTA = () => `Guarda`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const session_invalidError = () => `Sessione non valida.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const setting_other = () => `Impostazioni`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share = () => `Condividi`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_copyUrl = () => `Copia URL`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_description = () => `Puoi copiare l'URL pubblico del tuo badge per condividerlo sui social media, importarlo in altri collettori di badge, inviarlo tramite e-mail o includerlo nel tuo CV.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCode_description = () => `Mostra questo codice QR o salvalo sul tuo dispositivo per condividere il tuo badge con altri, ad esempio invitando qualcuno a sostenerti.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCode_heading = () => `Condividi tramite codice QR`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCodeImageAltText = () => `Un'immagine del codice QR che può essere scansionata con un telefono o uno scanner`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status = () => `Stato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_accepted = () => `Accettato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_created = () => `Creato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited = () => `Invitato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited_description = () => `Sei stato invitato a reclamare questo badge, ma non l'hai accettato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited_medium = () => `Invitato a richiedere un badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_loading = () => `Caricamento...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_notYetReviewed = () => `Questo badge è ancora in fase di revisione.`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_notYetReviewed_description = (params) => `Non ancora esaminato. Questo badge sarà valido una volta accumulati ${params.count} valutazioni da parte dei titolari di:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_prerequisiteRequired = () => `Prerequisito richiesto`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_rejected = () => `Respinto`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_rejected_description = () => `Sei stato invitato a reclamare questo badge, ma hai rifiutato questa richiesta. Nessun altro membro della community vedrà che hai ottenuto l'obiettivo.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_underReview = () => `In fase di revisione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_valid = () => `Valido`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_verified = () => `verificato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const submitCTA = () => `Invia`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tagline = () => `Ti auguro una giornata proficua.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const termsOfService = () => `Termini di servizio`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const themeCTA_description = () => `Alterna la modalità chiara e quella scura dell'interfaccia.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tos_agreementCTA_description = () => `Accetto i Termini di servizio e l'Informativa sulla privacy per questa community`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const unauthenticatedError = () => `Non autenticato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const uncategorized = () => `Non categorizzato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const url = () => `Indirizzo URL`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const verificationCode = () => `Codice di verifica`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view = () => `Visualizzazione`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const writeCTA = () => `Scrivere`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const yourEmail = () => `La tua email`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const removeCTA = () => `Rimuovere`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const changeCta = () => `Modifica`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_selectThisCTA = () => `Seleziona questo risultato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_searchByName = () => `Cerca i risultati per nome`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_noneFound = () => `Nessun risultato trovato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_noneFound_description = () => `Questa comunità non ha risultati visibili.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_errorLoading = () => `Errore durante il caricamento dei risultati`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_requireAReview = () => `Richiedi una revisione prima che i premi siano validi`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_chooseCTA = () => `Scegli il risultato`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_anAdminReviewRequired = () => `I reclami devono essere esaminati da un amministratore.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const inviteRequires_notFound = () => `Risultato richiesto per invitare non trovato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiredCrossValidationMessage = () => `Se è richiesta la revisione da parte del titolare, è necessario selezionare un badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardByInvitation = () => `Non reclamabile. Premio solo su invito.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiresLabel = () => `È richiesta una revisione?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiresLabelSpecific = () => `Recensito dai titolari di un badge specifico: `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteRequiresLabel = () => `Chi può invitare le persone a reclamare un badge?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_requirementHoldersOf = () => `Titolari di un badge specifico: `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chooseCTA = () => `Scegliere...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_errorFetchingData = () => `Errore durante il recupero dei dati!`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_errorFetchingData = () => `Errore durante il recupero dei risultati!`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_claimRequiresCrossValidationMessage = () => `Se la richiesto, è necessario selezionare un risultato.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteREquiresCrossValidationMessage = () => `Se è richiesta la revisione tramite invito, è necessario selezionare un badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteRequiredGeneric = () => `Questo risultato può essere conferito solo su invito.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_inviteRequiresDescription = () => `Gli inviti a presentare richiesta possono essere inoltrati dai titolari di:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const authentication_couldNotLogIn = () => `Impossibile effettuare l'accesso.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bad_bold_shrimp_express = () => `Data`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tense_raw_cuckoo_dart = () => `Non puoi invitare altri a reclamare questo risultato, perché il tuo badge di qualificazione non è ancora valido.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const known_such_scallop_gaze = () => `Rifiutare`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const proof_funny_dog_pat = () => `Accettare`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sunny_grand_lemur_race = () => `Indirizzo email non valido`




	
/**
 * @param {{ achievementName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const dull_bright_ostrich_delight = (params) => `Immagine del badge ${params.achievementName}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const merry_trite_seahorse_relish = () => `Per questo risultato hai ricevuto un badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gray_fluffy_myna_pet = () => `Recensito da un amministratore`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const aqua_alive_cougar_tickle = () => `Solo amministratori`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home_vivid_mole_gaze = () => `Puoi controllare il modo in cui il tuo profilo viene visualizzato dagli altri utenti della community e il modo in cui ti vengono fornite le tue credenziali.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const nice_active_giraffe_propel = () => `Identificatore`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const warm_male_thrush_pout = () => `Tipo`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const clear_crazy_meerkat_nurture = () => `Visibilità`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const short_deft_lemur_clasp = () => `Pubblico`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const equal_small_dolphin_spur = () => `Solo per i membri della comunità`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pink_last_marten_grin = () => `Privato (solo amministratori)`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const best_sweet_termite_work = () => `Chi può vedere i badge che hai guadagnato per impostazione predefinita? Puoi scegliere di ignorare questa impostazione per ogni singolo badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const direct_plane_boar_succeed = () => `Visibilità del badge predefinita`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const every_flat_lamb_favor = () => `Scegliere...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const fancy_antsy_ray_gaze = () => `No`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tired_top_fish_bask = () => `Richiesto dai titolari di un badge specifico:`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const factual_agent_mantis_jump = () => `Errore sconosciuto`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const elegant_free_cow_cherish = () => `Ciò che rende questa comunità speciale è...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const grand_tangy_cheetah_buy = () => `Slogan`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const moving_east_okapi_shrine = () => `Festeggia le tue capacità nella comunità.`

